import { ApiGroup } from './model/ApiGroup';
import api from './base';
import { ProductStates } from './apiTypes';
import { GeneratedDocument } from './generateddocuments/generatedDocumentsApiTypes';
import { mockExportReportResponse } from './listingMock';

const REPORT_EXPORT_URL = '/management/listing/report/export';
const REPORT_IMPORT_URL = '/management/listing/report/import';

export enum ReportType {
  NEW_PRODUCTS_FOR_LISTING = 'NEW_PRODUCTS_FOR_LISTING',
  OFFERS_WITH_MISSING_PARAMETERS = 'OFFERS_WITH_MISSING_PARAMETERS',
  ALL_OFFERS = 'ALL_OFFERS',
}

export type ExportReportRequest = {
  reportType: ReportType;
  apiGroup: ApiGroup;
  categories: string[];
  brands: string[];
  partnerProductCodes: string[];
  statuses: ProductStates[];
  marketplaceCodes: string[];
  minimumInStock?: number | null;
  withErrors?: boolean | null;
  excludeParameters: boolean;
};

export async function exportReport(
  request: ExportReportRequest,
  signal?: AbortSignal,
): Promise<GeneratedDocument> {
  const response = await api.post<GeneratedDocument>(REPORT_EXPORT_URL, request, {
    signal,
  });

  return response.data;
}

api.mock
  .onPost(/\/management\/listing\/report\/export/)
  .reply(200, mockExportReportResponse);

export async function importReport(
  formData: FormData,
  apiGroup: ApiGroup,
  signal?: AbortSignal,
): Promise<void> {
  const response = await api.post<void>(`${REPORT_IMPORT_URL}/${apiGroup}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    signal,
  });

  return response.data;
}

api.mock
  .onPost(/\/management\/listing\/report\/import\/.+/)
  .reply(200);
